module.exports = __webpack_public_path__ + "static/media/otp-star.5247bc4f.png";